export const TEXT_NODES = ['P', 'H1', 'H2', 'H3', 'H4', 'H5', 'H6', 'LI', 'TD', 'TH', 'A', 'LABEL', 'BUTTON', 'DIV', 'DT', 'DL', 'DD'];
export const STYLE_NODES = ['SPAN', 'BR', 'I', 'B', 'U', 'S', 'A', 'STRONG', 'EM'];

export const isLeafNode = (element: HTMLElement): boolean => {
  const childNodes = Array.from(element.childNodes);
  return childNodes.every((node) => {
    if (node.nodeType === Node.TEXT_NODE) return true;
    if (node.nodeType === Node.ELEMENT_NODE) {
      const el = node as HTMLElement;
      return STYLE_NODES.includes(el.tagName);
    }
    return false;
  });
};

export const findEditableParent = (element: HTMLElement): HTMLElement | null => {
  let current = element;

  // If clicked on a style node, traverse up to find the appropriate parent
  while (current && STYLE_NODES.includes(current.tagName) && !TEXT_NODES.includes(current.tagName)) {
    if (current.parentElement) {
      current = current.parentElement;
    } else {
      break;
    }
  }

  // Check if the current element is a valid text node and is a leaf node
  // Ignore nodes that only contain &nbsp; (non-breaking space)
  // Allow zero-width space \u200B (used as placeholder for empty elements)
  const isOnlyNbsp = current.innerText === '\u00A0';

  if (TEXT_NODES.includes(current.tagName) && isLeafNode(current) && !isOnlyNbsp) {
    return current;
  }

  return null;
};
